import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from 'react';
import { Button } from '../../../common/Button';
import styles from './TimeOutResendButton.scss';

const initialCountdownTimeSeconds = 59;
const intervalMills = 1000;
const secondsStringLength = 2;

let interval: NodeJS.Timeout;
const launchCountDownTimer = (
  setCountdownResetTimer: React.Dispatch<React.SetStateAction<number>>,
  setIsResetButtonEnabled: (enabled: boolean) => void,
) => {
  interval = setInterval(() => {
    setCountdownResetTimer((value) => {
      if (value <= 1) {
        clearInterval(interval);
        setIsResetButtonEnabled(true);

        return 0;
      }

      return value - 1;
    });
  }, intervalMills);
};

interface TimeOutResendButtonProps {
  onResendClick: () => Promise<unknown>;
}

const TimeOutResendButton = ({ onResendClick }: TimeOutResendButtonProps) => {
  const [countdownResetTimer, setCountdownResetTimer] = useState(initialCountdownTimeSeconds);
  const [isResetButtonEnabled, setIsResetButtonEnabled] = useState(false);
  const [isResendButtonLoading, setIsResendButtonLoading] = useState(false);

  useEffect(() => {
    launchCountDownTimer(setCountdownResetTimer, setIsResetButtonEnabled);
  }, []);

  const handleResendClick = () => {
    setIsResendButtonLoading(true);

    onResendClick()
      .catch(() => {})
      .finally(() => {
        setIsResetButtonEnabled(false);
        setCountdownResetTimer(initialCountdownTimeSeconds);
        launchCountDownTimer(setCountdownResetTimer, setIsResetButtonEnabled);

        setIsResendButtonLoading(false);
      });
  };

  return (
    <div className={styles.resendEmailBlock}>
      {isResetButtonEnabled ? (
        <Button
          kind="tertiary"
          loading={isResendButtonLoading}
          className={styles.resendEmailButton}
          onClick={handleResendClick}
        >
          <FormattedMessage
            id="authScreen.otcForm.resendEmailButton"
            defaultMessage="Resend email"
            description="Button that resends OTC email"
          />
        </Button>
      ) : (
        <span className={styles.resendEmailCountdown}>
          <FormattedMessage
            id="authScreen.otcForm.resendEmailCountdown"
            defaultMessage="Resend email in"
            description="Countdown timer for the resend email button"
          />{' '}
          {countdownResetTimer > 0 && (
            <b className={styles.resendEmailTimer}>
              0:{countdownResetTimer.toString().padStart(secondsStringLength, '0')}
            </b>
          )}
        </span>
      )}
    </div>
  );
};

export default TimeOutResendButton;
